module.exports = __webpack_public_path__ + "26cc6209c8f5c6624b7bca49bc5323.svg";